/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Map_TargetsInputs */

const en_us2_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Targets`)
};

const pt_br2_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvos`)
};

const es_419_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivos`)
};

const pt_pt2_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvos`)
};

const fr_fr2_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cibles`)
};

const de_de2_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielmuskeln`)
};

const it_it2_exercise_sheet_map_targets = /** @type {(inputs: Exercise_Sheet_Map_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principali`)
};

/**
* | output |
* | --- |
* | "Targets" |
*
* @param {Exercise_Sheet_Map_TargetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_map_targets = /** @type {((inputs?: Exercise_Sheet_Map_TargetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Map_TargetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_map_targets(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_map_targets(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_map_targets(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_map_targets(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_map_targets(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_map_targets(inputs)
	return en_us2_exercise_sheet_map_targets(inputs)
});
export { exercise_sheet_map_targets as "exercise-sheet.map_targets" }